// <input> types that don't take typed text (no on-screen keyboard, no Enter-to-submit).
export const NON_TEXT_INPUT_TYPES = [
  'checkbox',
  'radio',
  'range',
  'button',
  'submit',
  'reset',
  'file',
  'color',
  'image'
];
